import $ from 'jquery';
import Masonry from 'masonry-layout';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import Flickity from 'flickity';
//import '@fancyapps/ui/dist/fancybox.umd';
//import 'slick-carousel';

/* ==========================================================================
   Remove 'no-js' class
   ========================================================================== */

document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add("fade-in--is-visible");
            } else {
                //entry.target.classList.remove("fade-in--is-visible");
            }
        });
    });
    var items = document.querySelectorAll(".fade-in");
    items.forEach(function (item, index) {
        observer.observe(item, index);
    });
} else {
    document.querySelector("body").classList.add("no-intersection-observer");
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

$('.js-header__nav-toggle').on('click', function () {
    var expand = $(this).attr('aria-expanded') == 'false';
    $(this).attr('aria-expanded', expand);
    $('.js-navigation').attr('aria-expanded', expand);
    var title = $(this).attr('title');
    $(this).attr('title', $(this).data('alt-title'));
    $(this).data('alt-title', title);
});

/* ==========================================================================
   Header Navigation
   ========================================================================== */

$(window).scroll(function () {
    $('.js-header').toggleClass('is-sticky', $(window).scrollTop() > 0);
});

/* ==========================================================================
   Sub Nav Toggle
   ========================================================================== */

if (window.matchMedia("(max-width: 1023px)").matches) {
    $('.c-navigation__item').attr('aria-expanded', 'false');
}


$('.js-megamenu__heading').on('click', function (e) {
    e.preventDefault();
    var $item = $(this).parents('.c-navigation__item');

    $('.c-navigation__item').not($item).attr('aria-expanded', false);

    if ($item.attr('aria-expanded') === 'true') {
        $item.attr('aria-expanded', false);
    } else {
        $item.attr('aria-expanded', true);
    }
});

document.addEventListener('click', e => {
    if (!e.target.closest('.js-megamenu__heading')) {
        $('.c-navigation__item').attr('aria-expanded', false);
    }
});

/* ==========================================================================
   Back to top
   ========================================================================== */

$('.js-back-to-top').on('click', function (e) {
    e.preventDefault();
    $('body,html').animate({
        scrollTop: 0
    }, 800);
    return false;
});

$(window).scroll(function () {
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 300) {
        $('.js-back-to-top').addClass('fade-in');
    } else {
        $('.js-back-to-top').removeClass('fade-in');
    }
});

/* ==========================================================================
   Expand Collapse
   ========================================================================== */

if (window.matchMedia("(max-width: 1023px)").matches) {
    $('.js-expand-collapse').attr('aria-expanded', 'false');
    $('.js-expand-collapse__trigger').attr('aria-pressed', 'false') 
}

$('.js-expand-collapse__trigger').on('click', function (e) {
    e.preventDefault();
    var expand = $(this).attr('aria-pressed') == 'false';
    $(this).attr('aria-pressed', expand);
    $(this).parents('.js-expand-collapse').attr('aria-expanded', expand);
});


/* ==========================================================================
   History Timeline
   ========================================================================== */

// https://wpdevdesign.com/fixing-flickitys-issue-with-ios15-safari/
let touchingCarousel = false
let startXCoordinate

document.querySelector("body").addEventListener('touchstart', e => {
    if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true
    } else {
        touchingCarousel = false
        return
    }
    startXCoordinate = e.touches[0].pageX
})

document.querySelector("body").addEventListener('touchmove', e => {
    if (
        !touchingCarousel ||
        !e.cancelable ||
        Math.abs(e.touches[0].pageX - startXCoordinate) < 8
    ) return
    e.preventDefault()
    e.stopPropagation()
}, {
    passive: false
})

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function () {
    if (!this.isAnimating) {
        resize.call(this);
    }
};

$('.js-history').each(function () {
    var $timeline = $(this).find('.js-history__timeline');
    var timeline = new Flickity($timeline[0], {
        prevNextButtons: true,
        autoPlay: false,
        wrapAround: false,
        pageDots: false,
        cellAlign: 'left',
        contain: true
    });
    var $rotator = $(this).find('.js-history__rotator');
    var rotator = new Flickity($rotator[0], {
        prevNextButtons: true,
        autoPlay: false,
        wrapAround: false,
        lazyLoad: 2,
        pageDots: false,
        cellAlign: 'left'
    });

    $timeline.find('.js-history__timeline-item').each(function (i) {
        $(this).css('transform', 'translate(' + i * 100 + '%, -' + i * 100 + '%)');
    });
    $rotator.find('.js-history__rotator-item').each(function (i) {
        $(this).css('transform', 'translate(' + i * 100 + '%, -' + i * 100 + '%)');
    });

    $timeline.on('click', '.js-history__timeline-button', function () {
        var $currentItem = $(this).closest('.js-history__timeline-item');
        var year = $currentItem.data('history-year');
        $currentItem.closest('.js-history__timeline').find('.js-history__timeline-item').removeClass('is-selected').find('.js-history__timeline-button').removeAttr('aria-current');
        $currentItem.addClass('is-selected');
        $(this).attr('aria-current', true);

        var rotatorItems = $rotator.find('.js-history__rotator-item');
        var yearItem = rotatorItems.filter('[data-history-year="' + year + '"]');
        var yearItemIndex = rotatorItems.index(yearItem);

        rotator.select(yearItemIndex);
    });

    $rotator.on('click', '.flickity-button', function () {
        var $currentItem = $(rotator.selectedElement);
        var year = $currentItem.data('history-year');

        var timelineItems = $timeline.find('.js-history__timeline-item');
        var yearItem = timelineItems.filter('[data-history-year="' + year + '"]');
        var yearItemIndex = timelineItems.index(yearItem);

        timeline.select(yearItemIndex);

        // Update the timeline item to be selected
        timelineItems.removeClass('is-selected').find('.js-history__timeline-button').removeAttr('aria-current');
        yearItem.addClass('is-selected').find('.js-history__timeline-button').attr('aria-current', true);
    });
});

/* ==========================================================================
   Swiper Initialize
   ========================================================================== */

if ($('.swiper.js-rotator')) {
    new Swiper('.swiper.js-rotator[data-rotator-type="inspiration"]', {
        modules: [Navigation, Pagination],
        preloadImages: true,
        lazy: true,
        initialSlide: 0,
        zoom: {
            toggle: true,
        },
        autoplay: false,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    new Swiper('.swiper.js-rotator[data-rotator-type="gallery"]', {
        modules: [Navigation],
        preloadImages: true,
        loop: true,
        zoom: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    new Swiper('.swiper.js-rotator[data-rotator-type="carousel"]', {
        modules: [Navigation],
        preloadImages: true,
        zoom: true,
        spaceBetween: 10,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 6,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
    new Swiper('.swiper.js-rotator[data-rotator-type="hero-banner"]', {
        modules: [Navigation, Pagination],
        preloadImages: true,
        loop: true,
        autoplay: {
            delay: 4000,
        },
        pagination: {
            el: '.hero-swiper-pagination',
            clickable: true,
        },
    });
    new Swiper('.swiper.js-rotator[data-rotator-type="modal"]', {
        modules: [Navigation, Pagination],
        preloadImages: true,
        loop: true,
        zoom: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
}

/* ==========================================================================
   Video Popup
   ========================================================================== */

$('.js-video-group__item').on('click', function () {
    $(this).toggleClass('is_open');
    if ($(this).hasClass('is_open')) {
        var videoId = $(this).find('.js-video-cover').data('video-id');
        var vimeoId = $(this).find('.js-video-cover').data('vimeo-id');
        if (videoId) {
            $(this).find('.PlayBox').append('<iframe src="https://www.youtube.com/embed/' +videoId+'?autoplay=1&rel=0" frameborder="0" allow="autoplay;" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>');
        }
        else if (vimeoId) {
            $(this).find('.PlayBox').append('<iframe src="https://player.vimeo.com/video/' +vimeoId+'?autoplay=1&rel=0" width="900" height="100" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" data-ready="true"></iframe>');
        }
    } else {
        $(this).find('.PlayBox').html('');
    }
});

$(document).ready(function () {
    $('.js-video-cover').on('click', function (event) {
        event.preventDefault();

        const $videoPlayer = $(this).closest('.js-video-player');
        const $playBox = $videoPlayer.find('.PlayBox');
        const $playIcon = $videoPlayer.find('.c-video__icon');

        const videoId = $(this).data('video-id');
        const vimeoId = $(this).data('vimeo-id');

        if ($playBox.children('iframe').length === 0) {
            let embedUrl = '';

            if (vimeoId) {
                embedUrl = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1';
            } else if (videoId) {
                embedUrl = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
            }

            if (embedUrl) {
                $playBox.html('<iframe src="' + embedUrl + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
                $playIcon.hide();
            }
        } else {
            $playBox.html('');
            $playIcon.show();
        }
    });

});


/* ==========================================================================
   Region Button & Modal
   ========================================================================== */

const regionButton = document.querySelector(".js-modal-trigger");
if (regionButton) {
    const modalElement = document.querySelector("#modal-region-selector");
    regionButton.addEventListener("click", function () {
        modalElement.classList.toggle("c-regions-modal-isactive");
    });
    const regionCloseButton = document.querySelector(".js-modal-close");
    regionCloseButton.addEventListener("click", function () {
        modalElement.classList.toggle("c-regions-modal-isactive");
    });
}

/* ==========================================================================
   Filters
   ========================================================================== */

$(document).on('click', '.js-form-clear', function () {
    $(this).parents('.c-filter__body').find('.c-fake-checkbox').removeAttr('checked');
});

$('.js-select-link').on('change', function() {
    const selectedValue = $(this).val();
    const [baseUrl] = window.location.href.split('?');
    window.location.href = baseUrl + selectedValue;
});

/* ==========================================================================
   Resource Centre
   ========================================================================== */

$(document).on('click', '.js-basket-item-toggle', function () {
    var addToBasket = $(this).attr('aria-pressed') == 'false';
    $(this).attr('aria-pressed', addToBasket);
    $.ajax({
        url: "/umbraco/surface/ResourceCentre/" + (addToBasket ? "AddToBasket" : "RemoveFromBasket"),
        type: "GET",
        data: {
            id: $('.js-basket').data('resources-listing'),
            name: $(this).data('name'),
            file: $(this).data('file')
        },
        success: function (response) {
            $('.js-basket').replaceWith(response);
        }
    });
});

$(document).on('click', '.js-basket-delete', function () {
    $('.js-basket-item-toggle[data-name=\"' + $(this).data('name') + '\"]').attr('aria-pressed', false);
    $.ajax({
        url: "/umbraco/surface/ResourceCentre/RemoveFromBasket",
        type: "GET",
        data: {
            id: $('.js-basket').data('resources-listing'),
            name: $(this).data('name'),
            file: $(this).data('file')
        },
        success: function (response) {
            $('.js-basket').replaceWith(response);
        }
    });
});

$(document).on('click', '.js-basket__download-all', function () {
    var basket = $(this).parents('.js-basket').addClass('o-loader');
    window.location.href = '/umbraco/surface/ResourceCentre/DownloadBasket';
    basket.removeClass('o-loader');
});

/* ==========================================================================
   Product Resources
   ========================================================================== */

$(document).on('click', '.js-resources__file-container', function () {
    var resource = $(this).parents('.js-resources__item');
    var selected = resource.find('.js-resources__file:checked');
    if (selected.length) {
        resource.find('.js-resources__download').removeAttr('disabled');
    } else {
        resource.find('.js-resources__download').attr('disabled', '');
    }
});

$(document).on('click', '.js-resources__download', function () {
    var resource = $(this).parents('.js-resources__item');
    var name = resource.find('.js-resources__title').text() + ' ';
    var ids = '';
    resource.find('.js-resources__file:checked').each(function () {
        name += $(this).data('type') + ', ';
        ids += ',' + $(this).data('id');
    });
    if (ids.length) {
        name = name.substring(0, name.length - 2);
        window.location.href = '/umbraco/surface/ResourceCentre/DownloadItems?name=' + name + '&ids=' + ids.substring(1);
    }
});

/* ==========================================================================
   Modal
   ========================================================================== */

$(document).on('click', '.js-modal-trigger', function () {
    var id = $(this).attr('aria-controls');
    var modal = $('#' + id + '.js-modal');
    modal.attr('aria-hidden', false);
});

$(document).on('click', '.js-modal-close', function () {
    $(this).parents('.js-modal').attr('aria-hidden', true);
});
